<section class="services-hero dingo-section section-first">
  <div class="container">
    <div class="services-hero-grid">
      <div class="services-hero-copy">
        <div class="section-head reveal-on-scroll" data-reveal="section-head" data-reveal-trigger="immediate">
          <p class="services-kicker">Servicios DINGO</p>
          <h1 class="services-title">
            Soluciones digitales diseñadas para generar
            <span class="highlight-green">crecimiento real</span>
          </h1>
          <p class="services-desc">
            Marketing, tecnología, automatización y operación comercial trabajando bajo un mismo objetivo: vender más y
            escalar mejor.
          </p>
        </div>
        <div class="services-hero-actions reveal-on-scroll" data-reveal="button" data-reveal-trigger="immediate" style="--reveal-order: 1">
          <a class="dingo-cta-primary" routerLink="/contacto">
            Agenda diagnóstico
            <i class="bi bi-arrow-up-right"></i>
          </a>
          <a class="dingo-cta-secondary" href="#servicios-grid">
            Explorar servicios
            <i class="bi bi-grid"></i>
          </a>
        </div>
      </div>

      <figure class="dingo-hero-image-stage reveal-on-scroll" data-reveal="media" data-reveal-trigger="immediate" style="--reveal-order: 2">
        <div class="dingo-hero-image-stack">
          <img class="img-fluid dingo-cutout-edge-fix" src="assets/images/services/services.png" alt="Servicios digitales de marketing y tecnología DINGO" />
        </div>
      </figure>
    </div>
  </div>
</section>
